import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getProductList, deleteProductList } from '../actions/ProductListActions';
import { Pane, Heading, Button } from 'evergreen-ui';

import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import { Link } from 'react-router-dom';
import ProductListInfoBlock from '../components/ProductListInfoBlock';

class ViewProductList extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    
    componentDidMount() {
        this.props.dispatch(getProductList(this.id))
    }

    handleDelete = () => {
        this.props.dispatch(deleteProductList(this.id));
    }

    render() {
            
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/product-lists">
                            <Button iconBefore="arrow-left">
                                Inapoi la liste produse
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge lista de produse"
                            title="Confirmare stergere lista de produse"
                            confirmLabel="Sterg definitiv lista de produse"
                            message="Esti sigur ca vrei sa stergi lista de produse?"/>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Lista de produse - <strong>{this.props.productList.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <ProductListInfoBlock productList={this.props.productList}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        productList: state.productLists.current
    }
}

export default connect(mapStateToProps)(ViewProductList);